import { useState } from "react";
import {
  SCALEKIT_ENV_URL,
  SCALEKIT_CLIENT_ID,
  SCALEKIT_REDIRECT_URI,
  SCALEKIT_RESPONSE_TYPE,
  SCALEKIT_SCOPE,
} from "../config";
import { buildScalekitAuthorizeUrl } from "@libertify/auth/core";
import { Flex, Typography, Button, Input, Modal } from "antd";
import { useTranslate } from "@refinedev/core";
import { BuildingsIcon } from "@phosphor-icons/react";
import { socialBtnStyle } from "./SocialLogin";
import { useAnalytics } from "hooks/useAnalytics";
import { AnalyticsEvents } from "types/analytics";
import {
  clearPendingAuthMethod,
  setPendingAuthMethod,
} from "services/pendingAuthMethod";
import { serializeAttribution } from "utils/analytics";

export const ScalekitLogin = () => {
  const [scaleKitEmail, setScaleKitEmail] = useState("");
  const [open, setOpen] = useState(false);
  const t = useTranslate();
  const { trackEvent } = useAnalytics();

  const handleClick = () => {
    setOpen(false);
    const value = scaleKitEmail.trim();

    trackEvent(AnalyticsEvents.LoginAttempt, { login_method: "scalekit" });
    clearPendingAuthMethod();
    setPendingAuthMethod("scalekit");

    globalThis.location.href = buildScalekitAuthorizeUrl(
      {
        envUrl: SCALEKIT_ENV_URL,
        clientId: SCALEKIT_CLIENT_ID,
        redirectUri: SCALEKIT_REDIRECT_URI,
        responseType: SCALEKIT_RESPONSE_TYPE,
        scope: SCALEKIT_SCOPE,
        state: serializeAttribution(),
      },
      value.includes("@")
        ? { loginHint: value }
        : { organizationId: value }
    );
  };
  return (
    <Flex justify="center" align="center" vertical style={{ width: "100%" }}>
      <Modal open={open} onCancel={() => setOpen(false)} footer={null}>
        <Flex vertical gap={10} style={{ width: "100%" }}>
          <Typography.Title level={3} style={{ marginTop: 0 }}>
            {t("pages.auth.scalekit.title")}
          </Typography.Title>
          <Typography.Text>
            {t("pages.auth.scalekit.description")}
          </Typography.Text>
          <Input
            placeholder={t("pages.auth.scalekit.placeholder")}
            onChange={(e) => setScaleKitEmail(e.target.value)}
          />
          <Button
            type="primary"
            size="large"
            onClick={handleClick}
            disabled={!scaleKitEmail}
            style={{ marginTop: 10 }}
          >
            {t("pages.auth.scalekit.continue")}
          </Button>
        </Flex>
      </Modal>
      <Button
        onClick={() => setOpen(true)}
        size="large"
        icon={<BuildingsIcon size={20} />}
        style={socialBtnStyle}
      >
        {t("pages.auth.scalekit.open")}
      </Button>
    </Flex>
  );
};
